import React, { useRef, useState } from 'react';
import Resizer from 'react-image-file-resizer';
import Selfie from '../../components/perfil/Selfie';
import Cropper from 'react-easy-crop';
import Modal from '../layout/Modal';
import Icon from '@mdi/react';
import {
  mdiCamera,
  mdiImageEdit,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiUpload,
} from '@mdi/js';
import Botao from '../Botao';
import Grid, { GridItem } from '../layout/Grid';
import UsuarioAvatar from '../UsuarioAvatar';
import CampoTexto from '../Formulario/CampoTexto';
import CampoSenha from '../Formulario/CampoSenha';
import CampoSeletor from '../Formulario/CampoSeletor';

import { achievements } from '@tera/shared/src/achievements/constants';
import { useQuery } from 'react-query';
import { iconesConquistas } from '@/pages/perfil/iconesConquistas';

type Props = {
  initialValues?: any;
  fieldErrors?: any;
  onSubmit: (values: any) => Promise<any>;
  isSubmitting?: boolean;
};

export const FormPerfil = ({
  initialValues,
  fieldErrors,
  onSubmit,
  isSubmitting,
}: Props) => {
  const [foto, setFoto] = useState(null);
  const [fotoURL, setFotoURL] = useState<string>('/api/auth/me/avatar');
  const [showSelfie, setShowSelfie] = useState(false);

  const [showEditPhoto, setShowEditPhoto] = useState(false);

  const [cropArea, setCropArea] = useState(undefined);
  const [initialCropArea, setInitialCropArea] = useState(undefined);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const [value, setValue] = useState({
    nome: '',
    senha: '',
    confirmar_senha: '',
    mostrar_notificacoes: 'chatbot_atendimento',
    foto_dados_crop: {
      position: { x: 0, y: 0, width: 100, height: 100 },
      zoom: 1,
    },
    ...(initialValues ?? {}),
  });

  const qAchievements = useQuery({
    queryKey: ['achievements'],
    queryFn: async () => {
      const response = await fetch('/api/me/conquistas');
      return response.json();
    },
  })

  const achievementKeys = Object.keys(achievements);

  const onCropComplete = React.useCallback(
    (croppedArea: any, croppedAreaPixels: any) => {
      setCropArea(croppedArea);
    },
    [],
  );

  const fotoInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: any) => {
    processImage(e.target.files[0]);
  };

  const processImage = (file: any) => {
    const fotoFile = file;

    Resizer.imageFileResizer(
      fotoFile, // Is the file of the image which will resized.
      1024, // Is the maxWidth of the resized new image.
      768, // Is the maxHeight of the resized new image.
      'PNG', // Is the compressFormat of the resized new image.
      100, // Is the quality of the resized new image.
      0, // Is the degree of clockwise rotation to apply to uploaded image.
      (file: any) => {
        const reader = new FileReader();
        reader.onload = (e1: any) => {
          setFotoURL(e1.target.result as string);
          setFoto(file);
        };
        reader.readAsDataURL(file);
      }, // Is the callBack function of the resized new image URI.
      'file', // Is the output type of the resized new image.
      480, // Is the minWidth of the resized new image.
      320, // Is the minHeight of the resized new image.
    );
  };

  const onClose = () => {
    setFoto(null);
    setFotoURL('');
    setShowSelfie(false);
  };

  const onCancel = () => {
    onClose();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({ ...value, foto });
  };

  return (
    <>
      <Modal
        show={showSelfie}
        onClose={onClose}
        onCancel={onCancel}
        title="Selfie"
      >
        <Selfie
          onSelfieTaken={(uri: any) => {
            processImage(uri);
            setShowSelfie(false);
          }}
          active={showSelfie}
        />
      </Modal>
      <form onSubmit={handleSubmit}>
        <Grid>
          <Modal
            title="Editar Foto"
            show={showEditPhoto}
            onClose={() => setShowEditPhoto(false)}
            onCancel={() => setShowEditPhoto(false)}
            onConfirm={() => {
              setValue({
                ...value,
                foto_dados_crop: { position: cropArea, zoom },
              });
              setShowEditPhoto(false);
            }}
            confirmProps={{
              label: 'Alterar',
            }}
          >
            <div style={{ position: 'relative', height: '400px' }}>
              <Cropper
                image={fotoURL}
                crop={crop}
                onCropChange={setCrop}
                zoom={zoom}
                onZoomChange={setZoom}
                aspect={1}
                showGrid={true}
                cropShape="round"
                onCropComplete={onCropComplete}
                initialCroppedAreaPercentages={initialCropArea}
              />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div>
                <Icon path={mdiMagnifyMinusOutline} size={1} />
              </div>
              <div style={{ flex: 1 }}>
                <input
                  type="range"
                  value={zoom}
                  min={1}
                  max={3}
                  step={0.1}
                  aria-labelledby="Zoom"
                  onChange={e => setZoom(+e.target.value)}
                  style={{ textAlign: 'center', width: '100%' }}
                // classes={{ container: 'slider' }}
                />
              </div>
              <div>
                <Icon path={mdiMagnifyPlusOutline} size={1} />
              </div>
            </div>
          </Modal>

          <GridItem md={4} sm={12}>
            <div
              style={{
                border: '1px solid #ddd',
                padding: '10px',
                height: '100%',
                minHeight: '350px',
                position: 'relative',
              }}
            >
              <UsuarioAvatar imgSrc={fotoURL} />

              {value?.foto_dados_crop && fotoURL && (
                <div
                  style={{
                    position: 'absolute',
                    left: value.foto_dados_crop?.position?.x + '%',
                    top: value.foto_dados_crop?.position?.y + '%',
                    width: value.foto_dados_crop?.position?.width + '%',
                    height: value.foto_dados_crop?.position?.height + '%',
                    border: '4px dashed #8888',
                    borderRadius: '50%',
                  }}
                ></div>
              )}

              <div
                style={{
                  textAlign: 'center',
                  position: 'absolute',
                  bottom: '1rem',
                  left: 0,
                  right: 0,
                  margin: 'auto auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  justifyContent: 'center',
                }}
              >
                <Botao
                  variant="secondary"
                  onClick={() => fotoInputRef.current?.click()}
                  icon={mdiUpload}
                >
                  Foto
                </Botao>

                <Botao
                  variant="secondary"
                  onClick={() => setShowSelfie(true)}
                  icon={mdiCamera}
                >
                  Selfie!
                </Botao>

                <Botao
                  variant="secondary"
                  onClick={() => {
                    setInitialCropArea(value.foto_dados_crop?.position);
                    setCropArea(value.foto_dados_crop?.position);
                    setCrop(value.foto_dados_crop?.position ?? { x: 0, y: 0 });
                    setZoom(
                      Number.isSafeInteger(value.foto_dados_crop?.zoom)
                        ? +value.foto_dados_crop?.zoom
                        : 1,
                    );
                    setShowEditPhoto(true);
                  }}
                  icon={mdiImageEdit}
                >
                  Editar
                </Botao>
              </div>
            </div>
            <input
              ref={fotoInputRef}
              type="file"
              name="foto"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </GridItem>
          <GridItem md={8} sm={12}>
            <div style={{ position: 'absolute', height: 0 }}>
              <input
                type="text"
                name="username"
                style={{
                  height: 0,
                  width: 0,
                  border: 'none',
                  outline: 'none',
                  margin: 0,
                  padding: 0,
                }}
              />
              <input
                type="password"
                name="password"
                style={{
                  height: 0,
                  width: 0,
                  border: 'none',
                  outline: 'none',
                  margin: 0,
                  padding: 0,
                }}
              />
            </div>
            <Grid>
              <GridItem sm={12} md={6}>
                <CampoTexto
                  instanceId="conta"
                  disabled
                  label="Conta"
                  value={value.email}
                  onChange={v => setValue({ ...value, email: v })}
                  error={fieldErrors?.email}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoTexto
                  instanceId="nome"
                  label="Nome"
                  value={value.nome}
                  onChange={v => setValue({ ...value, nome: v })}
                  error={fieldErrors?.nome}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSenha
                  instanceId="senha"
                  label="Senha"
                  value={value.senha}
                  onChange={v => setValue({ ...value, senha: v })}
                  error={fieldErrors?.senha}
                  placeholder={value.id ? '(inalterada)' : ''}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSenha
                  instanceId="confirmar_senha"
                  label="Confirmar senha"
                  value={value.confirmar_senha}
                  onChange={v => setValue({ ...value, confirmar_senha: v })}
                  error={fieldErrors?.confirmar_senha}
                />
              </GridItem>
              <GridItem sm={12} md={6}>
                <CampoSeletor
                  instanceId="mostrar_notificacoes"
                  noSearch
                  label="Receber notificações"
                  value={value.mostrar_notificacoes}
                  onChange={v =>
                    setValue({ ...value, mostrar_notificacoes: v })
                  }
                  error={fieldErrors?.mostrar_notificacoes}
                  options={[
                    {
                      id: 'chatbot_atendimento',
                      label: 'Chatbot e atendimento',
                    },
                    { id: 'atendimento', label: 'Somente atendimento' },
                  ]}
                />
              </GridItem>
              <GridItem sm={12}>
                <h3 style={{ margin: '12px 0' }}>Minhas conquistas</h3>
              </GridItem>
              <GridItem sm={12}>
                <Grid>
                  {qAchievements.data && achievementKeys.map((k: any) => {
                    const conquista = qAchievements.data?.result?.find((it: any) => it.chave_conquista === k);
                    const conquistado = conquista && (achievements[k].limiarMin ? conquista.valor >= achievements[k].limiarMin : conquista.valor <= achievements[k].limiarMax);

                    const valor = achievements[k].unidade === 'ms' ? ((conquista?.valor ?? 0) / 1000).toFixed(1) + 's' : (conquista?.valor ?? 0).toString();
                    const limiar = achievements[k].unidade === 'ms' ? ((achievements[k].limiarMin ?? achievements[k].limiarMax) / 1000).toFixed(1) + 's' : (achievements[k].limiarMin ?? achievements[k].limiarMax).toString();

                    if (conquistado)
                      return (
                        <GridItem sm={3} md={2}>
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <div style={{
                              width: '120px',
                              height: '150px',
                              background: 'linear-gradient(145deg,rgb(255, 223, 162),rgb(255, 237, 204))',
                              border: `1px solid #daa520`,
                              boxShadow: '0px 0px 10px rgba(255, 215, 0, 0.6)',
                              color: '#4a2c00',
                              padding: '10px',
                              textAlign: 'center',
                              borderRadius: '12px',
                              transition: 'transform 0.15s ease-in-out',
                            }}
                              key={k}
                              title={achievements[k].descricao + (conquista ? ` (${valor} / ${limiar})` : '')}
                              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                            >
                              <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon path={iconesConquistas[k]} size={1.5} color={'var(--tc-color-success)'} /></div>
                              {achievements[k].titulo}
                            </div>
                          </div>
                        </GridItem>
                      )

                    return (
                      <GridItem sm={3} md={2}>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                          <div style={{
                            width: '120px',
                            height: '150px',
                            background: 'linear-gradient(145deg,var(--tc-color-gray-200),var(--tc-color-gray-100))',
                            border: `1px solid var(--tc-color-gray-300)`,
                            color: 'var(--tc-color-gray-400)',
                            padding: '10px',
                            textAlign: 'center',
                            borderRadius: '12px',
                            transition: 'transform 0.15s ease-in-out',
                          }}
                            key={k}
                            title={achievements[k].descricao + (conquista ? ` (${valor} / ${limiar})` : '')}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            <div style={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon path={iconesConquistas[k]} size={1.5} color={'var(--tc-color-gray-400)'} /></div>
                            {achievements[k].titulo}
                          </div>
                        </div>
                      </GridItem>
                    )

                  })}
                </Grid>

              </GridItem>
            </Grid>
          </GridItem>
          <GridItem sm={12}>
            <Botao variant="primary" type="submit" disabled={isSubmitting}>
              Salvar
            </Botao>
          </GridItem>
        </Grid>
      </form>
    </>
  );
};
